import { DatePicker, DatePickerProps, Flex } from 'antd';
import { createStyles } from 'antd-style';
import dayjs from 'dayjs';
import { getSettings } from '../../viewmodel/getsettings';
import { Dateformat } from '../sample/my-settings';

type RXDatePickerProps = {
    theme: string;
    date: Date | null;
    handleDateSelect: DatePickerProps['onChange'],
    minDate?: Date,
    isDateDisabled?: DatePickerProps['disabledDate']
}

const useStyles = createStyles((token) => ({
    root: {
        border: "1px solid #525252"
    },
    picker: {
        height: "24px !important",
        backgroundColor: "transparent !important",
        border: "0px  !important",
        '& .ant-picker-input > input': {
            height: "24px !important",
            backgroundColor: "transparent !important",
            margin: "0px !important",
            border: "0px  !important",
            color: "#ffff",
            padding: "10px !important"
        },
    },
    picker_light: {
        height: "24px !important",
        backgroundColor: "transparent !important",
        border: "0px  !important",
        '& .ant-picker-input > input': {
            height: "24px !important",
            backgroundColor: "transparent !important",
            margin: "0px !important",
            border: "0px  !important",
            color: "#1A1A1A",
            padding: "10px !important"
        },
    },
    popup: {
        '& .ant-picker-panel': {
            backgroundColor: '#1f1f1f',
        },
    }
}));


const RXDatePicker = ({
    theme,
    date,
    handleDateSelect,
    minDate,
    isDateDisabled
}: RXDatePickerProps) => {
    const { styles } = useStyles();
    const getSettingsData = getSettings;

    const setDateFormat = () => {
        let newFormattype;
        switch (getSettingsData.data.DateFormat) {
            case ('dd/MM/yyyy'):
                return newFormattype = 'DD/MM/YYYY';
            case ('MM/DD/YYYY'):
                return newFormattype = 'MM/DD/YYYY';
            case ('MMMM, DD, YYYY'):
                return newFormattype = 'MMMM, DD, YYYY';
            case ('MMMM, dddd D, YYYY'):
                return newFormattype = 'MMMM, dddd D, YYYY';

            case ('dddd, D MMMM YYYY'):
                return newFormattype = 'dddd, D MMMM YYYY';
            case ('dddd Do MMMM YYYY'):
                return newFormattype = 'dddd Do MMMM YYYY';

            default:
                return newFormattype = 'DD/MM/YYYY';

        }
    }
    const dateFormat = setDateFormat();

    return (
        <Flex vertical >
            <DatePicker
                format={dateFormat}
                className={theme === "dark" ? styles.picker : styles.picker_light}
                classNames={{
                    popup: {
                        root: styles.popup,
                    },
                }}
                suffixIcon={null}
                disabledDate={isDateDisabled}
                value={dayjs(date)}
                onChange={handleDateSelect}
                minDate={dayjs(minDate) ?? undefined}
            />
        </Flex>
    );
};

export default RXDatePicker;
